module.exports = __webpack_public_path__ + "static/media/sakura-background-light.feadf651.png";